import { Box, Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { useMeetingContext } from '../../../contexts/meeting/meetingContext';
import HeaderComponent from '../../common/headerComponent';
import MeetingDisclaimer from '../../meeting/disclamer';
import PreviewUserVideo from '../../meeting/previewUserVideo';

function PreVideoCallLayout() {
  const { startMeeting } = useMeetingContext();

  return (
    <>
      <HeaderComponent isMenuHidden />
      <Stack direction={'row'} justifyContent='center' marginTop={5}>
        <Stack gap={4}>
          <Stack direction={'row'} justifyContent='center'>
            <Stack gap={1}>
              <Typography
                sx={{
                  color: (theme) => theme.palette.neutralBlackBg[50],
                  textAlign: 'center',
                }}
                fontSize={{
                  xs: 21,
                  md: 28,
                }}
              >
                <FormattedMessage
                  defaultMessage='You have been invited to join on the{linebreak}Interview Meeting'
                  values={{ linebreak: <br /> }}
                />
              </Typography>
            </Stack>
          </Stack>

          <Stack direction={'row'} justifyContent='center' paddingX={2}>
            <Box
              sx={{
                maxWidth: '600px',
                minWidth: {
                  xs: '90vw',
                  sm: '70vw',
                  md: '600px',
                },
                position: 'relative',
                aspectRatio: '16/9',
              }}
            >
              <PreviewUserVideo />
            </Box>
          </Stack>

          <Stack direction={'row'} justifyContent='center'>
            <Button
              sx={{
                textTransform: 'none',
                display: 'flex',
                maxWidth: '240px',
                width: '100%',
                padding: '8px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                borderRadius: '50px',
                background: (theme) =>
                  `linear-gradient(294deg, ${theme.palette.teal.main} 16.77%, ${theme.palette.green[500]} 53.83%)`,
                color: '#181818',
              }}
              onClick={() => {
                startMeeting();
              }}
            >
              <FormattedMessage defaultMessage='Join call' />
            </Button>
          </Stack>
        </Stack>
      </Stack>
      <MeetingDisclaimer />
    </>
  );
}

export default PreVideoCallLayout;
